var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hp-header-text-info col col-lg-14 col-xl-16 hp-header-start-text d-flex align-items-center"})
}
var staticRenderFns = []

export { render, staticRenderFns }